import actions from './actions'
import mutations from './mutations'

const businessRegister = {
    namespaced: true,
    state: {
        referralCode: null,
        refStatus: null
    },
    actions,
    mutations
}

export default businessRegister
